{
  "remove": "Îndepărtaţi"
}
